import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M14 9l3 -3l3 3","key":"svg-0"}],["path",{"d":"M5 5.5a.5 .5 0 0 1 .5 -.5h4a.5 .5 0 0 1 .5 .5v4a.5 .5 0 0 1 -.5 .5h-4a.5 .5 0 0 1 -.5 -.5l0 -4","key":"svg-1"}],["path",{"d":"M5 14.5a.5 .5 0 0 1 .5 -.5h4a.5 .5 0 0 1 .5 .5v4a.5 .5 0 0 1 -.5 .5h-4a.5 .5 0 0 1 -.5 -.5l0 -4","key":"svg-2"}],["path",{"d":"M17 6v12","key":"svg-3"}]]

const IconSortAscending2 = createReactComponent('outline', 'sort-ascending-2', 'SortAscending2', __iconNode);

export default IconSortAscending2;